export default __webpack_public_path__ + "static/media/Instagram_white.91a5ffb0.svg";